import React from "react";
import moment from "moment";
import classNames from "classnames";
import { Tag, IconButton, Tooltip } from "@toddle-edu/ds-web";
import { CopyOutlined, CloseOutlined } from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";
import classes from "./PlaybackHeader.scss";

const PlaybackHeader = ({
  isEmptyDocument,
  name,
  stats,
  closePlaybackViewer,
}) => {
  const { t } = useI18n(["classRoom"]);

  const { lastEdited, timeTaken = 0, pasteCount = 0, totalEdits = 0 } =
    stats || {};

  const date = lastEdited
    ? moment(lastEdited).format("ddd, MMMM D, YYYY [at] hh:mm A")
    : "--";
  const formattedTimeTaken = moment
    .duration(timeTaken, "milliseconds")
    .format("h[h] m[m] s[s]", { trim: "both" });

  return (
    <div className={classes.headerContent}>
      <div className={classes.titleSection}>
        <Tooltip
          dsVersion="2.0"
          tooltip={name}
          showArrow={false}
          placement="topLeft"
        >
          <h6 className={classNames(classes.text)}>{name}</h6>
        </Tooltip>
        {!isEmptyDocument && (
          <Tooltip
            dsVersion="2.0"
            tooltip={t("classRoom:last_edited_on_date", { date })}
            showArrow={false}
            placement="bottomLeft"
          >
            <div
              className={classNames(
                "text-body-s",
                "text-textSubtle",
                classes.text
              )}
            >
              {t("classRoom:last_edited_on_date", { date })}
            </div>
          </Tooltip>
        )}
      </div>
      <div className={classes.headerStats}>
        {!isEmptyDocument && (
          <Tag dsVersion="2.0" size="medium">
            {formattedTimeTaken}
          </Tag>
        )}
        <Tag dsVersion="2.0" size="medium">
          {t("classRoom:edit_count", {
            count: totalEdits,
          })}
        </Tag>
        <Tag
          dsVersion="2.0"
          size="medium"
          color="yellow"
          prefix={<CopyOutlined />}
        >
          {t("classRoom:paste_count", { count: pasteCount })}
        </Tag>
        <IconButton
          dsVersion="2.0"
          size="small"
          variant="neutral"
          icon={<CloseOutlined />}
          onClick={closePlaybackViewer}
          style={{
            marginLeft: "8px",
          }}
        />
      </div>
    </div>
  );
};

export default PlaybackHeader;
